const navigationDefaults = {
  dashboard: false,
  containers: false,
  addContainer: false,
  shipment: false,
  customers: false,
  drivers: false,
  status: false,
  team: false,
  chassis: false,
  customerPortal: false,
  addTask: false,
  actions: false,
  tasks: false,
  users: false,
};

const mutationDefaults = {
  createContainers: false,
  updateContainers: false,
  assignDrivers: false,
  manageCustomers: false,
  manageDrivers: false,
  updateDispatchTasks: false,
  manageUsers: false,
};

function definePolicy(role, landingRoute, readableRoutes, navigation, mutations = {}) {
  return {
    role,
    landingRoute,
    readableRoutes,
    navigation: { ...navigationDefaults, ...navigation },
    mutations: { ...mutationDefaults, ...mutations },
  };
}

// Chassis Locations mirrors the callable's own allowlist
// (functions/src/anytrek-contract.ts ALLOWED_ROLES): admin, dispatcher, clerk,
// finance — never customer. A route this file opens that the callable refuses is
// a page that loads and then fails; the two are pinned together by
// tests/unit/chassis-route-parity.test.mjs.
const policies = {
  admin: definePolicy(
    'admin',
    '#/dashboard',
    [
      'dashboard', 'container', 'add-container', 'edit-status',
      'assign-driver', 'status', 'team', 'admin-users', 'chassis',
      'shipment-create', 'driver-task', 'edit-dispatch-task',
      'action', 'profile', 'customer-quotes', 'create',
    ],
    {
      dashboard: true,
      status: true,
      team: true,
      users: true,
      chassis: true,
    },
    {
      createContainers: true,
      updateContainers: true,
      assignDrivers: true,
      manageCustomers: true,
      manageDrivers: true,
      updateDispatchTasks: true,
      manageUsers: true,
    },
  ),
  dispatcher: definePolicy(
    'dispatcher',
    '#/dashboard',
    [
      'dashboard', 'container', 'add-container', 'edit-status',
      'assign-driver', 'status', 'team', 'chassis',
      'shipment-create', 'driver-task', 'edit-dispatch-task',
      'action', 'profile', 'customer-quotes', 'create',
    ],
    {
      dashboard: true,
      status: true,
      team: true,
      chassis: true,
    },
    {
      createContainers: true,
      updateContainers: true,
      assignDrivers: true,
      manageCustomers: true,
      manageDrivers: true,
      updateDispatchTasks: true,
    },
  ),
  clerk: definePolicy(
    'clerk',
    '#/dashboard',
    ['dashboard', 'container', 'status', 'driver-task', 'action', 'profile', 'chassis',
      'create'],
    { dashboard: true, status: true, chassis: true },
    { createContainers: true },
  ),
  customer: definePolicy(
    'customer',
    '#/dashboard',
    ['dashboard', 'customer-portal', 'container', 'add-task', 'action', 'profile', 'create'],
    { dashboard: true },
  ),
  finance: definePolicy(
    'finance',
    '#/dashboard',
    ['dashboard', 'container', 'status', 'team', 'driver-task', 'action', 'profile', 'chassis',
      'customer-quotes', 'create'],
    { dashboard: true, status: true, team: true, chassis: true },
    { createContainers: true },
  ),
};

export function policyForRole(role) {
  if (typeof role !== 'string' || !Object.hasOwn(policies, role)) return null;
  const policy = policies[role];
  return {
    ...policy,
    readableRoutes: [...policy.readableRoutes],
    navigation: { ...policy.navigation },
    mutations: { ...policy.mutations },
  };
}
